import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgxEchartsModule } from 'ngx-echarts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslatedPaginatorIntl } from './core/services/translated-paginator-intl.service';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { AfterLoginComponent } from './layout/after-login/after-login.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SetInterceptorService } from './core/interceptor/set-interceptor.service';
import { GetInterceptorService } from './core/interceptor/get-interceptor.service';

import { AfterLoginSharedModule } from './shared/after-login.shared.module';
import { ToastrModule } from 'ngx-toastr';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { InitialService } from './core/services/initial.service';
import { ModalsModule } from './modals/modals.module';

// initializeApp(environment.firebaseConfig);

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

type FactoryFunction = () => void;

export function initialServiceFactory(
  InitialService: InitialService
): FactoryFunction {
  return () => InitialService.setUpGoogleScript();
}
@NgModule({
  declarations: [AppComponent, AfterLoginComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgxUiLoaderModule,
    MatSelectModule,
    MatMenuModule,
    MatSidenavModule,
    AfterLoginSharedModule,
    HttpClientModule,
    MatSlideToggleModule,
    FormsModule,
    ModalsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    BrowserAnimationsModule
  ],

  exports: [TranslateModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: TranslatedPaginatorIntl
    },
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: initialServiceFactory,
      deps: [InitialService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptorService,
      multi: true
    },
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
